import styled from "styled-components"
import theme from "@irati/ui/src/global/theme"

interface ContainerProps {
  width?: number
}

export const ImageWrapper = styled.span`
  background: ${theme.colors.greys.lightest};
  border-radius: 50%;
  margin-right: 20px;
`

export const Container = styled.div<ContainerProps>`
  width: ${({width}) => width}%;
`
